export default __webpack_public_path__ + "static/media/__your__referrals.0737c1e4.svg";